<template>
  <div
    v-if="isVisible"
    class="hilo-modal-overlay"
    :class="{
      'bottom-right-overlay': bottomRight,
      'image-viewer-overlay': imageViewer,
    }"
  >
    <div
      class="hilo-modal"
      :class="{ 'bottom-right': bottomRight, 'image-viewer': imageViewer }"
      @click.stop
    >
      <button
        v-if="showCloseButton && !unCloseable"
        class="hilo-modal-close"
        @click="closeModal"
      >
        <i class="fas fa-times"></i>
      </button>
      <header v-if="showHeader" class="hilo-modal-header">
        <slot name="header">
          <h3>{{ title }}</h3>
        </slot>
      </header>
      <div class="hilo-modal-body">
        <slot></slot>
      </div>
      <footer v-if="hasFooter" class="hilo-modal-footer">
        <HiloButton
          v-for="button in footerButtons"
          :key="button.label"
          :label="button.label"
          :styleType="button.type"
          @click="button.onClick"
        />
      </footer>
    </div>
  </div>
</template>

<script>
import HiloButton from "./HiloButton.vue";

export default {
  components: {
    HiloButton,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    hasFooter: {
      type: Boolean,
      default: true,
    },
    footerButtons: {
      type: Array,
      default: () => [],
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    bottomRight: {
      type: Boolean,
      default: false,
    },
    imageViewer: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    unCloseable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      if (!this.unCloseable) {
        this.$emit("close");
      }
    },
  },
};
</script>

<style scoped>
.hilo-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.hilo-modal-overlay.bottom-right-overlay {
  pointer-events: none;
  background-color: transparent;
}

.hilo-modal-overlay.image-viewer-overlay {
  pointer-events: auto;
  z-index: 1002;
}

.hilo-modal {
  background-color: #d9d9d9;
  border-radius: 8px;
  width: 600px;
  max-width: 90%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
}

.hilo-modal.bottom-right {
  position: fixed;
  bottom: 50px;
  right: 50px;
  width: 600px;
  max-width: 600px;
  z-index: 1001;
  pointer-events: auto;
}

.hilo-modal.image-viewer {
  width: 50%;
  height: 90%;
  max-width: 1200px;
  max-height: 90%;
  z-index: 1003;
}

.hilo-modal-header {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #d9d9d9;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: 1px solid #f4f4f4;
  position: relative;
}

.hilo-modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
}

.hilo-modal-close i {
  font-size: 20px;
  color: #333;
  z-index: 1001;
}

.hilo-modal-body {
  padding: 16px;
  max-height: 400px;
  overflow-y: auto;
}

.hilo-modal.image-viewer .hilo-modal-body {
  max-height: 80vh;
}

.hilo-modal-footer {
  display: flex;
  justify-content: center;
  padding: 16px;
  border-top: 1px solid #f4f4f4;
  gap: 10px;
}
</style>
